export default "__VITE_ASSET__CnKmPmQq__"